import request from '@/utils/request'
import { useFd } from '@/utils/formData'

export function fetchOwnerList () {
  const data = useFd('AEW/Client/OwnerList', {
    __ds: 'site',
    __dbid: '2'
  })
  return request({
    method: 'post',
    data,
  })
}

export function login ({ email, psw }) {
  const data = useFd('AEW/Client/CourseUserLogin', {
    __ds: 'center',
    __dbid: '0',
    email:email,
    password:psw,
    __ds_origin: null,
    __dsid_origin: null
  })
  return request({
    method: 'post',
    data,
  })
}


//體驗課程清單
export function fetchCourseList ({ kw, gd, ctype=[], cid=[], city, scity=[], total=10, page=1 }) {
  const data = useFd('AEW/Client/CourseList', {
    __ds: 'site',
    __dbid: '2',
    grade: gd,
    search_kw: kw,
    course_city: city,
    get_total_num:total,
    page:page,

  })
    ctype.forEach(e => {
      data.append('type[]',e)
    })

    console.log(ctype)

    cid.forEach(e => {
      data.append('category_id[]', e)
    })

    scity.forEach(e => {
      data.append('school_city[]', e)
    })


  return request({
    method: 'post',
    data,
  })
}


//體驗課程詳細資料
export function fetchClassDetail ({ cID }) {
  const data = useFd('AEW/Client/CourseDetail', {
    __ds: 'site',
    __dbid: '2',
    course_number: cID,

  })
  return request({
    method: 'post',
    data,
  })
}



//申請體驗課程狀態List
export function fetchCourseApplicationList ({ u_str }) {
  const data = useFd('AEW/Client/CourseApplicationList', {
    __ds: 'site',
    __dbid: '2',
    u_str,

  })
  return request({
    method: 'post',
    data,
  })
}

//刪除山請體驗課程
export function delCourseApplicationList({ u_str_id, applicationId}){
  const data = useFd('AEW/Client/CourseApplicationDelete', {
    __ds: 'site',
    __dbid: '2',
    u_str: u_str_id,
    application_id:applicationId,
  })
  return request({
    method: 'post',
    data,
  })

}

//申請體驗課程細節
export function fetchCourseApplicationDetail ({ u_str, applicationId}) {
  const data = useFd('AEW/Client/CourseApplicationDetail', {
    __ds: 'site',
    __dbid: '2',
    u_str: u_str,
    application_id: applicationId,

  })
  return request({
    method: 'post',
    data,
  })
}




//找體驗課程--申請
export function updateClassApplication (payload) {
  const {
    u_str, course_id, course_number, application_id, school_code, school_name, school_type, school_city, principal, contact_name, contact_phone, school_address, school_intro, contact_email, contact_passwd, event_id
  } = payload
  const data = useFd('AEW/Client/CourseApplicationUpdate', {
    __ds: 'site',
    __dbid: 2,
    u_str,
    course_id,
    course_number,
    application_id,
    school_code:1,
    school_name,
    school_type:0,
    school_city,
    principal:"null",
    contact_name,
    contact_phone,
    school_address,
    school_intro:"null",
    contact_email,
    contact_passwd,
    event_id,


  })
  // if (addFiles.length > 0) {
  //   addFiles.forEach(f => {
  //     data.append('add_att_file[]', f)
  //   })
  // }
  // if (deleteFileIds.length > 0) {
  //   deleteFileIds.forEach(id => {
  //     data.append('del_att_id[]', id)
  //   })
  // }
  return request({
    method: 'post',
    data,
  })
}




// 忘記密碼
export function forgotPassword ({ email }) {
  const data = useFd('AEW/Client/GrantForgotPassword', {
    email,
    __ds: 'center',
    __dbid: '0',
    __ds_origin: null,
    __dsid_origin: null
  })
  return request({
    method: 'post',
    data,
  })
}








// WEBPACK FOOTER //
// ./src/api/client/Class.js